export const createSvcId = () =>
  `svc${crypto.randomUUID().replaceAll('-', '')}`;
